/**
 * The output tables a run wrote into: each names its table, how many rows the
 * run wrote there, and opens the table in its document.
 */
import { useI18n } from '@affine/i18n';
import { useService } from '@toeverything/infra';
import type { FC } from 'react';

import { WorkbenchService } from '../../../../workbench/services/workbench';
import type { OutputWrittenTable } from '../../../services/logging';
import * as styles from '../history-panel.css';
import { DataRow } from './row-primitives';

export const WrittenTablesRows: FC<{
  tables: readonly OutputWrittenTable[];
}> = ({ tables }) => {
  const t = useI18n();
  const workbench = useService(WorkbenchService).workbench;
  return (
    <>
      {tables.map(table => (
        <DataRow
          key={table.tableId}
          label={table.tableName}
          value={
            <button
              type="button"
              className={styles.smallButton}
              onClick={() =>
                workbench.openDoc({
                  docId: table.docId,
                  blockIds: [table.tableId],
                })
              }
            >
              {t['com.streamlain.streamlain.history.written-table-open']({
                count: table.rowCount,
              })}
            </button>
          }
        />
      ))}
    </>
  );
};
